<div class="content">
  <div class="content-panel-overflow">
  <form [formGroup]="searchForm" #form="ngForm" >
    <h2><label class="form-label" translate >page.declarations.dr.title </label>
    <input formControlName="annee" maxlength="4" class="form-control annee-input" [ngClass]="{'is-invalid': form.submitted && searchForm.get('annee').invalid}" /></h2>
   </form>
   <div id="liste-dr"
         *ngIf="(declarations?.length > 0 || declarationsSv11?.length > 0 || declarationsSv12?.length > 0 || declarationsDpCave?.length > 0 || declarationsDpNego?.length > 0 || declarationsDpRecoltant?.length > 0); else aucunProduit">

      <!-- Tableau des déclarations -->
      <table table class="table table-striped" aria-label="Liste des déclarations" *ngIf="declarations.length > 0">
        <thead>
        <tr>
          <th scope="col" colspan="2"></th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l4</th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l5</th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l15</th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l16</th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l18</th>
          <th scope="col" class="liste-col-header" translate>page.declarations.dr.table.header.l19</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let declaration of declarations">
          <tr>
            <td>
              <fa-icon *ngIf="declaration.details.length && !declaration.showDetails" style="font-size:1.3em;"
                       icon="plus" (click)="declaration.showDetails = true" class="pointer"></fa-icon>
              <fa-icon *ngIf="declaration.details.length && declaration.showDetails" style="font-size:1.3em;"
                       icon="minus" (click)="declaration.showDetails = false" class="pointer"></fa-icon>
            </td>
            <td>{{declaration.produit?.libelle}}<span *ngIf="declaration.mention"> - {{declaration.mention}}</span>
            </td>
            <td>{{declaration.l4 | number:'1.4-4' }}</td>
            <td>{{declaration.l5 | number:'1.2-2' }}</td>
            <td>{{declaration.l15 | number:'1.2-2' }}</td>
            <td>{{declaration.l16 | number:'1.2-2' }}</td>
            <td>{{declaration.l18 | number:'1.2-2' }}</td>
            <td>{{declaration.l19 | number:'1.2-2' }}</td>
            <td class="align-center">
              <button *ngIf="declaration.erreurs && declaration.erreurs.length; else declarationOk" type="button"
                      class="btn btn-danger" translate>
                <fa-icon style="margin-right:0.7em;" icon="bell"></fa-icon>
                page.declarations.dr.table.modifier_dr
              </button>
              <ng-template #declarationOk>
                  <span class="btn btn-success pointer-none">
                    <fa-icon style="font-size:1.2em;" icon="check"></fa-icon>
                  </span>
              </ng-template>
            </td>
          </tr>
          <ng-container *ngIf="declaration.showDetails">
            <ng-container *ngFor="let detail of declaration.details">
              <tr>
                <td style="background-color: #ccc"></td>
                <td>{{declaration.produit?.libelle}} - {{declaration.mention}}</td>
                <td>{{detail.l4 | number:'1.4-4' }}</td>
                <td>{{detail.l5 | number:'1.2-2' }}</td>
                <td>{{detail.l15 | number:'1.2-2' }}</td>
                <td>{{detail.l16 | number:'1.2-2' }}</td>
                <td>{{detail.l18 | number:'1.2-2' }}</td>
                <td>{{detail.l19 | number:'1.2-2' }}</td>
                <td>
                  <ng-container *ngIf="declaration.erreurs.length > 0">
                    <!-- Afficher toutes les erreurs de la liste -->
                    <span *ngFor="let erreur of declaration.erreurs; let last = last">
                      {{ erreur }}<span *ngIf="!last">, </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!declaration.erreurs.length">
                    <!-- Ici, vous pourriez afficher quelque chose si aucune erreur n'est présente ou simplement rien -->
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        </tbody>
      </table>
      <!-- Fin tableau des déclarations -->

      <!-- Tableau des déclarations SV11 -->
      <div *ngIf="declarationsSv11?.length > 0">
        <h2 translate>page.declarations.dr.table_sv11.title</h2>
        <table aria-label="Liste des déclarations SV11" class="table table-striped">
          <thead>
          <tr>
            <th scope="col" colspan="2"></th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.superficie</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.volume_apporte</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.volume_cree</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.volume_distillation</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.vsi</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv11.header.vci</th>
            <th scope="col"></th>
          </tr>
          </thead>

          <tbody>
          <ng-container *ngFor="let declarationSv11 of declarationsSv11">
            <tr>
              <td>
                <fa-icon *ngIf="declarationSv11.details.length && !declarationSv11.showDetails"
                         style="font-size:1.3em;" icon="plus" (click)="declarationSv11.showDetails = true"
                         class="pointer">
                </fa-icon>
                <fa-icon *ngIf="declarationSv11.details.length && declarationSv11.showDetails"
                         style="font-size:1.3em;" icon="minus" (click)="declarationSv11.showDetails = false"
                         class="pointer">
                </fa-icon>
              </td>
              <td>{{ declarationSv11.produit?.libelle }}<span *ngIf="declarationSv11.mention"> -
                {{ declarationSv11.mention }}</span></td>
              <td>{{ declarationSv11.sup_rec | number:'1.4-4' }}</td>
              <td>{{ declarationSv11.vol_app | number:'1.2-2' }}</td>
              <td>{{ declarationSv11.vol_cree | number:'1.2-2' }}</td>
              <td>{{ declarationSv11.vol_dplc | number:'1.2-2' }}</td>
              <td>{{ declarationSv11.vol_vsi | number:'1.2-2' }}</td>
              <td>{{ declarationSv11.vol_vci | number:'1.2-2' }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="declarationSv11.showDetails">
              <ng-container *ngFor="let detail of declarationSv11.details">
                <tr>
                  <td style="background-color: #ccc"></td>
                  <td>{{ declarationSv11.produit?.libelle }} - {{ declarationSv11.mention }}</td>
                  <td>{{ detail.sup_rec | number:'1.4-4' }}</td>
                  <td>{{ detail.vol_app | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_cree | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_dplc | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vsi | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vci | number:'1.2-2' }}</td>
                  <td>{{ detail.erreurs }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Fin tableau des déclarations SV11 -->

      <!-- Tableau des déclarations SV12 -->
      <div *ngIf="declarationsSv12?.length > 0">
        <h2 translate>page.declarations.dr.table_sv12.title</h2>
        <table class="table table-striped" aria-label="Liste des déclarations SV12">
          <thead>
          <tr>
            <th scope="col" colspan="2"></th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv12.header.superficie</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv12.header.quantite_achat</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv12.header.volume_achat</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv12.header.volume_vf</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_sv12.header.volume_mouts</th>
            <th scope="col"></th>
          </tr>
          </thead>

          <tbody>
          <ng-container *ngFor="let declarationSv12 of declarationsSv12">
            <tr>
              <td>
                <fa-icon *ngIf="declarationSv12.details.length && !declarationSv12.showDetails"
                         style="font-size:1.3em;" icon="plus" (click)="declarationSv12.showDetails = true"
                         class="pointer">
                </fa-icon>
                <fa-icon *ngIf="declarationSv12.details.length && declarationSv12.showDetails"
                         style="font-size:1.3em;" icon="minus" (click)="declarationSv12.showDetails = false"
                         class="pointer">
                </fa-icon>
              </td>
              <td>{{ declarationSv12.produit?.libelle }}<span *ngIf="declarationSv12.mention"> -
                {{ declarationSv12.mention }}</span></td>
              <td>{{ declarationSv12.s_recolte | number:'1.4-4' }}</td>
              <td>{{ declarationSv12.qte_achat_vf | number:'1.2-2' }}</td>
              <td>{{ declarationSv12.vol_achat_m | number:'1.2-2' }}</td>
              <td>{{ declarationSv12.vol_issu_vf | number:'1.2-2' }}</td>
              <td>{{ declarationSv12.vol_issu_m | number:'1.2-2' }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="declarationSv12.showDetails">
              <ng-container *ngFor="let detail of declarationSv12.details">
                <tr>
                  <td style="background-color: #ccc"></td>
                  <td>{{ declarationSv12.produit?.libelle }} - {{ declarationSv12.mention }}</td>
                  <td>{{ detail.s_recolte | number:'1.4-4' }}</td>
                  <td>{{ detail.qte_achat_vf | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_achat_m | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_vf | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_m | number:'1.2-2' }}</td>
                  <td>{{ detail.erreurs }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Fin tableau des déclarations SV12 -->


            <!-- Tableau des déclarations DP CAVE -->
      <div *ngIf="declarationsDpCave?.length > 0">
        <h2 translate>page.declarations.dr.table_dpcave.title</h2>
        <table class="table table-striped" aria-label="Liste des déclarations DP CAVE">
          <thead>
          <tr>
            <th scope="col" colspan="2"></th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.superficie</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_apport_raisin</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_issu_raisin</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_apport_mout</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_issu_mout</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_a_eliminer</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_vci</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.volume_vsi</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpcave.header.rendement</th>
            <th scope="col"></th>
          </tr>
          </thead>

          <tbody>
          <ng-container *ngFor="let declarationDpCave of declarationsDpCave">
            <tr>
              <td>
                <fa-icon *ngIf="declarationDpCave.details.length && !declarationDpCave.showDetails"
                         style="font-size:1.3em;" icon="plus" (click)="declarationDpCave.showDetails = true"
                         class="pointer">
                </fa-icon>
                <fa-icon *ngIf="declarationDpCave.details.length && declarationDpCave.showDetails"
                         style="font-size:1.3em;" icon="minus" (click)="declarationDpCave.showDetails = false"
                         class="pointer">
                </fa-icon>
              </td>
              <td>{{ declarationDpCave.produit?.libelle }}<span *ngIf="declarationDpCave.mention"> -
                {{ declarationDpCave.mention }}</span></td>
              <td>{{ declarationDpCave.s_recolte | number:'1.4-4' }}</td>
              <td>{{ declarationDpCave.vol_app_r | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_issu_r | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_app_m | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_issu_m | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_a_elim | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_vci | number:'1.2-2' }}</td>
              <td>{{ declarationDpCave.vol_vsi | number:'1.2-2' }}</td>
              <td>{{ (declarationDpCave.vol_issu_r + declarationDpCave.vol_issu_m) / declarationDpCave.s_recolte | number:'1.2-2' }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="declarationDpCave.showDetails">
              <ng-container *ngFor="let detail of declarationDpCave.details">
                <tr>
                  <td style="background-color: #ccc"></td>
                  <td>{{ detail.apport }} </td>
                  <td>{{ detail.s_recolte | number:'1.4-4' }}</td>
                  <td>{{ detail.vol_app_r | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_r | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_app_m | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_m | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_a_elim | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vci | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vsi | number:'1.2-2' }}</td>
                  <td>{{ (detail.vol_issu_r + detail.vol_issu_m) / detail.s_recolte | number:'1.2-2' }}</td>
                  <td>{{ detail.erreurs }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Fin tableau des déclarations DP CAVE -->

                  <!-- Tableau des déclarations DP NEGO -->
      <div *ngIf="declarationsDpNego?.length > 0">
        <h2 translate>page.declarations.dr.table_dpnego.title</h2>
        <table class="table table-striped" aria-label="Liste des déclarations DP NEGO">
          <thead>
          <tr>
            <th scope="col" colspan="2"></th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.superficie</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.volume_achat_raisin</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.volume_issu_raisin</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.volume_achat_mout</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.volume_issu_mout</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dpnego.header.rendement</th>
            <th scope="col"></th>
          </tr>
          </thead>

          <tbody>
          <ng-container *ngFor="let declarationDpNego of declarationsDpNego">
            <tr>
              <td>
                <fa-icon *ngIf="declarationDpNego.details.length && !declarationDpNego.showDetails"
                         style="font-size:1.3em;" icon="plus" (click)="declarationDpNego.showDetails = true"
                         class="pointer">
                </fa-icon>
                <fa-icon *ngIf="declarationDpNego.details.length && declarationDpNego.showDetails"
                         style="font-size:1.3em;" icon="minus" (click)="declarationDpNego.showDetails = false"
                         class="pointer">
                </fa-icon>
              </td>
              <td>{{ declarationDpNego.produit?.libelle }}<span *ngIf="declarationDpNego.mention"> -
                {{ declarationDpNego.mention }}</span></td>
              <td>{{ declarationDpNego.s_recolte | number:'1.4-4' }}</td>
              <td>{{ declarationDpNego.qte_ach_r | number:'1.2-2' }}</td>
              <td>{{ declarationDpNego.vol_issu_r | number:'1.2-2' }}</td>
              <td>{{ declarationDpNego.vol_ach_m | number:'1.2-2' }}</td>
              <td>{{ declarationDpNego.vol_issu_m | number:'1.2-2' }}</td>
              <td>{{ (declarationDpNego.vol_issu_r + declarationDpNego.vol_issu_m) / declarationDpNego.s_recolte | number:'1.2-2' }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="declarationDpNego.showDetails">
              <ng-container *ngFor="let detail of declarationDpNego.details">
                <tr>
                  <td style="background-color: #ccc"></td>
                  <td>{{ detail.fournisseur }} </td>
                  <td>{{ detail.s_recolte | number:'1.4-4' }}</td>
                  <td>{{ detail.qte_ach_r | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_r | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_ach_m | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_issu_m | number:'1.2-2' }}</td>
                  <td>{{ (detail.vol_issu_r + detail.vol_issu_m) / detail.s_recolte | number:'1.2-2' }}</td>
                  <td>{{ detail.erreurs }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Fin tableau des déclarations DP NEGO -->
                         <!-- Tableau des déclarations DP RECOLTANT -->
      <div *ngIf="declarationsDpRecoltant?.length > 0">
        <h2 translate>page.declarations.dr.table_dprecoltant.title</h2>
        <table class="table table-striped" aria-label="Liste des déclarations DP RECOLTANT">
          <thead>
          <tr>
            <th scope="col" colspan="2"></th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.superficie</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.recolte_totale</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.vol_vinrevendicable_ou_commercialisable</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.vci</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.vsi</th>
            <th scope="col" class="liste-col-header" translate>page.declarations.dr.table_dprecoltant.header.rendement</th>
            <th scope="col"></th>
          </tr>
          </thead>

          <tbody>
          <ng-container *ngFor="let declarationDpRecoltant of declarationsDpRecoltant">
            <tr>
              <td>
                <fa-icon *ngIf="declarationDpRecoltant.details.length && !declarationDpRecoltant.showDetails"
                         style="font-size:1.3em;" icon="plus" (click)="declarationDpRecoltant.showDetails = true"
                         class="pointer">
                </fa-icon>
                <fa-icon *ngIf="declarationDpRecoltant.details.length && declarationDpRecoltant.showDetails"
                         style="font-size:1.3em;" icon="minus" (click)="declarationDpRecoltant.showDetails = false"
                         class="pointer">
                </fa-icon>
              </td>
              <td>{{ declarationDpRecoltant.produit?.libelle }}<span *ngIf="declarationDpRecoltant.mention"> -
                {{ declarationDpRecoltant.mention }}</span></td>
              <td>{{ declarationDpRecoltant.superficie_recolte | number:'1.4-4' }}</td>
              <td>{{ declarationDpRecoltant.recolte_totale | number:'1.2-2' }}</td>
              <td>{{ declarationDpRecoltant.vol_vinrevendicable_ou_commercialisable | number:'1.2-2' }}</td>
              <td>{{ declarationDpRecoltant.vci | number:'1.2-2' }}</td>
              <td>{{ declarationDpRecoltant.vsi | number:'1.2-2' }}</td>
              <td>{{ declarationDpRecoltant.vol_vinrevendicable_ou_commercialisable / declarationDpRecoltant.superficie_recolte  | number:'1.2-2' }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="declarationDpRecoltant.showDetails">
              <ng-container *ngFor="let detail of declarationDpRecoltant.details">
                <tr>
                  <td style="background-color: #ccc"></td>
                  <td>{{ declarationDpRecoltant.produit?.libelle }}<span *ngIf="declarationDpRecoltant.mention"> -
                {{ declarationDpRecoltant.mention }}</span></td>
                  <td>{{ detail.superficie_recolte | number:'1.4-4' }}</td>
                  <td>{{ detail.recolte_totale | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vinrevendicable_ou_commercialisable | number:'1.2-2' }}</td>
                  <td>{{ detail.vci | number:'1.2-2' }}</td>
                  <td>{{ detail.vsi | number:'1.2-2' }}</td>
                  <td>{{ detail.vol_vinrevendicable_ou_commercialisable / detail.superficie_recolte | number:'1.2-2' }}</td>
                  <td>{{ detail.erreurs }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Fin tableau des déclarations DP RECOLTANT -->
    </div>
    <div class="actions-bar"
         *ngIf="(declarations && declarations.length) || (declarationsSv11 && declarationsSv11.length) || (declarationsSv12 && declarationsSv12.length) || (declarationsDpCave && declarationsDpCave.length) || (declarationsDpNego && declarationsDpNego.length) || (declarationsDpRecoltant && declarationsDpRecoltant.length)">
      <button type="button" (click)="goDrev()"  class="btn btn-primary" [disabled]="hasErrors"
              translate>label.suivant
      </button>
    </div>
  </div>
</div>

<ng-template #aucunProduit>
  <div class="alert alert-warning alert-block" translate [translateParams]="{annee:annee.value}">
    <fa-icon icon="exclamation"></fa-icon>
    page.declarations.dr.table.aucunProduit
  </div>
</ng-template>

